<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M17 21.4336V16.4541H15V21.4336H17Z" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2788 7.5C14.1742 7.5 13.2788 8.39543 13.2788 9.5V11.0889L23 11.0889C24.1046 11.0889 25 11.9843 25 13.0889V20.5002C25 24.3662 21.866 27.5002 18 27.5002H14C10.134 27.5002 7 24.3662 7 20.5002V13.0889C7 11.9843 7.89543 11.0889 9 11.0889H11.2788V9.5C11.2788 7.29086 13.0697 5.5 15.2788 5.5H16.7207C17.8624 5.5 18.8938 5.9797 19.6214 6.74578L20.31 7.47088L18.8598 8.84817L18.1712 8.12306C17.8055 7.73803 17.2917 7.5 16.7207 7.5H15.2788ZM23 20.5002V13.0889H9V20.5002C9 23.2616 11.2386 25.5002 14 25.5002H18C20.7614 25.5002 23 23.2616 23 20.5002Z"
        />
    </svg>
</template>
